import { render, staticRenderFns } from "./bulk.vue?vue&type=template&id=b55544ac&scoped=true&"
import script from "./bulk.vue?vue&type=script&lang=js&"
export * from "./bulk.vue?vue&type=script&lang=js&"
import style0 from "./bulk.vue?vue&type=style&index=0&id=b55544ac&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b55544ac",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/circleci/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('b55544ac', component.options)
    } else {
      api.reload('b55544ac', component.options)
    }
    module.hot.accept("./bulk.vue?vue&type=template&id=b55544ac&scoped=true&", function () {
      api.rerender('b55544ac', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/deals/bulk.vue"
export default component.exports